/** Copyright (c) 2020 T. Rowe Price. All rights reserved. */
import './ViewFeeSummaryModal.scss';

import { string } from 'prop-types';
import React, { useState } from 'react';

import BaseModal from 'components/shared/Modal/BaseModal';

const ViewFeeDetailsModal = ({ detail }) => {
  const [isOpen, setOpen] = useState(false);

  return (
    <div className="ras-modal">
      <BaseModal
        title="Retirement Advisory Service Fee"
        linkContent="View Fee Details"
        linkContentClass="fee-summary-modal-link"
        closeTitle={null}
        open={() => setOpen(true)}
        close={() => setOpen(false)}
        isOpen={isOpen}
        disableFixed
        hideIcon>
        <div dangerouslySetInnerHTML={{ __html: detail }} />
      </BaseModal>
    </div>
  );
};

ViewFeeDetailsModal.propTypes = {
  detail: string
};

export default ViewFeeDetailsModal;
